import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#667085",
      "fill-rule": "evenodd",
      d: "M10.332 1.334c-.92 0-1.667.746-1.667 1.667v10c0 .92.747 1.666 1.667 1.666h2.667c.92 0 1.666-.746 1.666-1.666V3c0-.92-.746-1.667-1.666-1.667zm-.333 1.667c0-.184.149-.334.333-.334h2.667c.184 0 .333.15.333.334v10c0 .184-.15.333-.333.333h-2.667a.333.333 0 0 1-.333-.333zm-7 4.333c-.92 0-1.667.746-1.667 1.667v4c0 .92.746 1.666 1.667 1.666h2.666c.92 0 1.667-.746 1.667-1.666V9c0-.92-.746-1.667-1.667-1.667zm-.334 1.667c0-.184.15-.334.334-.334h2.666c.184 0 .334.15.334.334v4c0 .184-.15.333-.334.333H3a.333.333 0 0 1-.334-.333z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }